/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

export default new Uint8Array([0x00, 0x00, 0x00, 0x01]);